<template>
  <a class="btn btn-dark" >複製 </a>
</template>

<script type="text/javascript">
export default {

}
</script>